package util

import kotlinx.browser.document
import org.khronos.webgl.Uint8Array
import org.w3c.dom.HTMLAnchorElement
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

object DownloadHelper {
    fun triggerDownload(byteArray: ByteArray, fileName: String, fileType: String) {
        val uint8Array = Uint8Array(byteArray.toTypedArray())

        @Suppress("UNUSED_VARIABLE") // used in js below
        val blob = Blob(arrayOf(uint8Array), BlobPropertyBag(type = fileType))

        // Generate a temporary URL for the Blob
        val url = js("URL.createObjectURL(blob)") as String

        // Create a temporary <a> element to trigger the download
        val a = (document.createElement("a") as HTMLAnchorElement).apply {
            href = url
            download = fileName
        }

        document.body?.appendChild(a)
        a.click()
        document.body?.removeChild(a)
        js("URL.revokeObjectURL(url)")
    }
}